import React from 'react';
export function DashboardShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-14827">
      <span className="sr-only" data-id="element-14828">Loading dashboard…</span>
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-14829">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-14830">
            <div className="flex justify-between items-start mb-4" data-id="element-14831">
              <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-14832" />
              <div className="w-10 h-10 bg-gray-200 rounded-md" data-id="element-14833" />
            </div>
            <div className="h-8 w-40 bg-gray-200 rounded mb-2" data-id="element-14834" />
            <div className="h-3 w-24 bg-gray-200 rounded" data-id="element-14835" />
          </div>)}
      </div>
      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-14836">
        {[1, 2].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-14837">
            <div className="flex justify-between items-center mb-4" data-id="element-14838">
              <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-14839" />
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-14840" />
            </div>
            <div className="h-64 bg-gray-200 rounded-md" data-id="element-14841" />
          </div>)}
      </div>
      {/* Activity Section */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-14842">
        <div className="h-5 w-40 bg-gray-200 rounded mb-4" data-id="element-14843" />
        <div className="space-y-3" data-id="element-14844">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="flex items-center gap-4 p-3 border border-gray-200 rounded-lg" data-id="element-14845">
              <div className="w-10 h-10 bg-gray-200 rounded-full" data-id="element-14846" />
              <div className="flex-1 space-y-2" data-id="element-14847">
                <div className="h-4 w-64 bg-gray-200 rounded" data-id="element-14848" />
                <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-14849" />
              </div>
              <div className="h-4 w-20 bg-gray-200 rounded" data-id="element-14850" />
            </div>)}
        </div>
      </div>
    </div>;
}